<template>
  <nav
    class="navbar navbar-expand-lg navbar-light shadow-sm fixed-top edu-navbar"
    :class="{ 'navbar-shift': sidebarOpen }"
  >
    <div class="container-fluid d-flex align-items-center justify-content-between">
      <!-- Sidebar toggle -->
      <button class="btn btn-outline-light me-2" @click="$emit('toggle-sidebar')">
        <i class="bi bi-list fs-5"></i>
      </button>

      <!-- Brand -->
      <router-link
        to="/"
        class="navbar-brand fw-bold d-flex align-items-center brand-text m-0"
        v-show="!sidebarOpen"
      >
        <img src="@/assets/edu-logo.png" alt="EduLearn Logo" class="me-2 edu-logo" />
        <span class="site-name">{{ siteName }}</span>
      </router-link>

      <!-- Navbar Links (Right Side) -->
      <div class="d-none d-lg-flex ms-auto align-items-center">
        <router-link to="/courses" class="btn btn-outline-light btn-sm me-2">
          Courses
        </router-link>
        <router-link to="/about" class="btn btn-outline-light btn-sm me-2">
          About
        </router-link>
        <router-link to="/contact" class="btn btn-primary btn-sm fw-bold">
          Contact
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    sidebarOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      siteName: "EduLearn Academy",
    };
  },
};
</script>

<style scoped>
/* Navbar Background */
.edu-navbar {
  background-color: #0d6efd;
  color: #fff;
  z-index: 1050;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  transition: margin-left 0.3s ease;
  padding: 0.5rem 1rem;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.navbar-shift {
  margin-left: 250px;
}

/* Brand */
.edu-logo {
  width: 40px;
  height: 40px;
  transition: all 0.3s ease;
}

.site-name {
  font-size: 1.3rem;
  color: #fff;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}

/* Center brand on normal screen */
.navbar .brand-text {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}

/* Mobile Adjustments */
@media (max-width: 991px) {
  .brand-text {
    position: static;
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  .edu-logo {
    width: 32px;
    height: 32px;
    margin-right: 6px;
  }

  .site-name {
    font-size: 1rem;
  }

  .navbar-shift .brand-text {
    display: none !important;
  }
}

/* Buttons */
.btn-outline-light {
  color: #fff;
  border-color: #fff;
  transition: all 0.3s;
}
.btn-outline-light:hover {
  background-color: #fff;
  color: #0d6efd;
  border-color: #fff;
}

.btn-primary {
  background-color: #ffc107;
  color: #212529;
  border: none;
  transition: all 0.3s;
}
.btn-primary:hover {
  background-color: #ffca2c;
  color: #000;
  transform: translateY(-2px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
</style>
